import React, { useEffect } from "react";
import {
  validateName, validateEmail, validateContactNumber,
  validateAddressLines, validatePostCode, validateABN, validateTFN
} from "../../Validations";
import { CleanerBaiscDetails } from "./AddCleanerComponents/CleanerBaiscDetails";
import { AddedCleaners } from "./AddCleanerComponents/AddedCleaners";
import { useUserContext } from "../../../_context/UserContext";
import { CleanerAddressDetails } from "./AddCleanerComponents/CleanerAddressDetails";
import { submitCleaner } from "../../../_utils/resourceAPI";
import { useCleanerContext } from "../../../_context/CleanerContext";
import EmptyCleaner from "../../../_resources/JsonData/EmptyCleaner.json";
import SuccessfullSubmission from "../Notifications/SuccessfullSubmission";
import { createDateISO } from "../../../_constrains/dates";
import { CleanerTaxABN } from "./AddCleanerComponents/CleanerTaxABNData";
import { useState } from "react";
import "../AddUsers/AddUsers.css";

export const AddCleaners = () => {
  const { setCurrentPage } = useUserContext();
  const { cleaner, setCleaner, setCleanerUpdated } = useCleanerContext();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => { setCurrentPage("Add Cleaners"); }, [setCurrentPage]);

  const resetForm = () => setCleaner(EmptyCleaner);

  const submitCleanerHandler = (e: React.FormEvent) => {
    e.preventDefault();
    const newCleanerData = { ...cleaner, CreateDate: createDateISO };
    submitCleaner(newCleanerData)
      .then(() => { setShowSuccessModal(true); resetForm(); setCleanerUpdated(true); })
      .catch(() => console.log("Something went wrong"));
  };

  const isFormValid = () =>
    !validateName(cleaner.Name, true, "") &&
    !validateEmail(cleaner.Email, true, "") &&
    !validateContactNumber(cleaner.Phone, true, "") &&
    !validateAddressLines(cleaner.Address.Line1, true) &&
    !validateAddressLines(cleaner.Address.Line2, false) &&
    !validateAddressLines(cleaner.Address.Suburb, true) &&
    !validatePostCode(cleaner.Address.Postcode.toString(), true) &&
    !validateABN(cleaner.ABNNo, false);

  return (
    <div className="add-users-page">
      {/* Left: form card */}
      <div className="au-card">
        <div className="au-card-header">
          <div className="au-card-header-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 20l-7-7" /><path d="M9 3l-.5 9.5L4 18h16l-4.5-5.5L15 3H9z" />
            </svg>
          </div>
          <div>
            <p className="au-card-header-title">Add New Cleaner</p>
            <p className="au-card-header-sub">Register a new cleaning staff member</p>
          </div>
        </div>
        <div className="au-card-body">
          <form onSubmit={submitCleanerHandler} noValidate>
            <CleanerBaiscDetails
              cleanerNameValidator={validateName}
              cleanerEmailValidator={validateEmail}
              cleanerContactNumberValidator={validateContactNumber}
            />

            <div style={{ height: 1, background: "#E5E7EB", margin: "20px 0" }} />
            <p style={{ fontSize: "0.8rem", fontWeight: 700, color: "#9CA3AF", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>
              Address Details
            </p>
            <CleanerAddressDetails
              addressValidator={validateAddressLines}
              postCodeValidator={validatePostCode}
            />

            <div style={{ height: 1, background: "#E5E7EB", margin: "20px 0" }} />
            <CleanerTaxABN
              cleanerABNValidate={validateABN}
              cleanerTFNValidate={validateTFN}
            />

            <button
              type="submit"
              className="au-submit-btn"
              style={{ marginTop: 20 }}
              disabled={!isFormValid()}
            >
              Add Cleaner
            </button>
          </form>
        </div>
      </div>

      {/* Right: cleaners table card */}
      <div className="au-card">
        <div className="au-card-header">
          <div className="au-card-header-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
              <rect x="9" y="3" width="6" height="4" rx="1" />
              <line x1="9" y1="12" x2="15" y2="12" /><line x1="9" y1="16" x2="13" y2="16" />
            </svg>
          </div>
          <div>
            <p className="au-card-header-title">CNA Cleaners</p>
            <p className="au-card-header-sub">All registered cleaning staff</p>
          </div>
        </div>
        <div className="au-card-body">
          <AddedCleaners />
        </div>
      </div>

      <SuccessfullSubmission
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successMessage="Cleaner Added Successfully"
      />
    </div>
  );
};
